import { render, staticRenderFns } from "./ProductLine.vue?vue&type=template&id=db3923be&"
import script from "./ProductLine.vue?vue&type=script&lang=js&"
export * from "./ProductLine.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('db3923be')) {
      api.createRecord('db3923be', component.options)
    } else {
      api.reload('db3923be', component.options)
    }
    module.hot.accept("./ProductLine.vue?vue&type=template&id=db3923be&", function () {
      api.rerender('db3923be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/catalog/product-line/ProductLine.vue"
export default component.exports